module.exports = __webpack_public_path__ + "img/fail1.03408084.png";